import { Component, OnInit } from '@angular/core';
import { ProfileAdvancedSearchParams } from '../../profile-advanced-search-params.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';
import { NotificationService } from 'src/app/shared';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'wl-assign-user-search-action',
  templateUrl: './assign-user-search-action.component.html',
  styleUrls: ['./assign-user-search-action.component.less'],
    standalone: false
})
export class AssignUserSearchActionComponent implements OnInit {
  public selectedUserId = 0;

  constructor(private _profileService: ProfileService, private _notifyService: NotificationService) {}

  ngOnInit(): void {}

  public massAssignProfileUser(searchParams: ProfileAdvancedSearchParams) {
    this._profileService.assignProfilesUserAdvanced(searchParams, this.selectedUserId).then(() => {
      this._notifyService.translateSuccess('profiles.search.assign-user-success');
    });
  }
  public assignProfilesUser(profileIds: Array<number>) {
    this._profileService
      .assignProfilesUser(profileIds, this.selectedUserId)
      .then(() => {
        this._notifyService.translateSuccess('common.success');
      })
      .catch((error) => {
        this._notifyService.httpError(error);
      });
  }
}
